import React, { useRef, useState } from "react";
import {
  Grid,
  Select,
  Button,
  MenuItem,
  TextField,
  FormControl,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";

const CreditSimStatus = () => {
  const [data, setData] = useState<any>(null);
  const [msisdn, setmsisdn] = useState("");
  const [email, setEmail] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [product, setProduct] = useState<number>(1);
  const [name, setName] = useState<string>("");
  const [transactionId, setTransactionId] = useState<string>("");
  const [orderId, setOrderId] = useState<string>("");
  const [cardFourDigit, setCardFourDigit] = useState<string>("");

  const [action, setAction] = useState<Boolean>(false);
  const agGridRef = useRef<AgGridReact | null>(null);

  const exportGridDataAsCSV = () => {
    if (agGridRef.current) {
      agGridRef.current.api.exportDataAsCsv();
    }
  };
  const columnDefs: ColDef[] = [
    {
      field: "msisdn",
      headerName: "Msisdn",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "email",
      headerName: "Email",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "Name",
      headerName: "User Name",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "ordereddate",
      headerName: "Ordered Date",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "fulfillmentdate",
      headerName: "Fulfillment Date",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "transactiontype",
      headerName: "Transaction Type",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "PaymentId",
      headerName: "Transaction ID",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "Paymentdate",
      headerName: "Payment Date",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "SimActivationDate",
      headerName: "SimActivation Date",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "BundleAmount",
      headerName: "BundleAmount",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "TopupAmount",
      headerName: "TopupAmount",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "bundlename",
      headerName: "Bundle Name",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "Address",
      headerName: "Address",
      filter: true,
      resizable: true,
      sortable: true,
    },
  ];
  const handleGetBundles = async () => {
    setData(null);
    toast.dismiss();
    if (
      msisdn.trim().length > 9 ||
      email.trim() !== "" ||
      address.trim() !== "" ||
      name.trim() !== "" ||
      transactionId.trim() !== "" ||
      orderId.trim() !== "" ||
      cardFourDigit.trim().length == 4
    ) {
      setAction(true);
      requestBundles();
    } else {
      toast.error("Please enter valid  input.");
    }
  };
  const handleClear = () => {
    setmsisdn("");
    setEmail("");
    setAddress("");
    setName("");
    setTransactionId("");
    setOrderId("");
    setCardFourDigit("");
  };
  const requestBundles = async () => {
    await axiosInterceptorInstance
      .get(
        `/dashboard/CreditSimStatus?MSISDN=${msisdn.trim()}&Email=${email.trim()}&Address=${address.trim()}&Product=${product}&Name=${name.trim()}&TransactionId=${transactionId.trim()}&OrderId=${orderId.trim()}&CardFourDigit=${cardFourDigit.trim()}`,
      )
      .then((res: any) => {
        setAction(false);
        const apiresponse = JSON.parse(res.data.body);
        if (apiresponse.Data?.length == 0 || apiresponse?.Data == null) {
          toast.error("Record not found.");
        } else {
          setData(apiresponse?.Data);
          setEmail(apiresponse.Data[0].email);
          setAddress(apiresponse.Data[0].Address);
          setName(apiresponse.Data[0].Name);
          setmsisdn(
            apiresponse.Data[0].msisdn != null
              ? apiresponse.Data[0].msisdn
              : "",
          );
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Credit Sim Status</h2>
        <div className="boxInner">
          <Grid container columnSpacing={2}>
            <Grid item xs={4}>
              <FormControl style={{ width: "100%", backgroundColor: "white" }}>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className="formControl"
                  autoWidth
                  value={product}
                  defaultValue={product}
                  onChange={(e: any) => {
                    setProduct(parseInt(e.target.value));
                  }}
                >
                  <MenuItem value="1">THM</MenuItem>
                  <MenuItem value="2">NOW</MenuItem>
                  <MenuItem value="6">RWG</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="MSISDN"
                variant="outlined"
                value={msisdn}
                onChange={(e) => setmsisdn(e.target.value)}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="Card Last 4 Digits"
                variant="outlined"
                value={cardFourDigit}
                onChange={(e) => setCardFourDigit(e.target.value)}
                inputProps={{ maxLength: 4 }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="Email"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                inputProps={{ maxLength: 40 }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="Address"
                variant="outlined"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                inputProps={{ maxLength: 100 }}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            <Grid item xs={5}>
              <TextField
                className="formControl"
                label="Transaction ID"
                variant="outlined"
                value={transactionId}
                onChange={(e) => setTransactionId(e.target.value)}
                inputProps={{ maxLength: 30 }}
              />
            </Grid>
            <Grid item xs={5}>
              <TextField
                className="formControl"
                label="Order ID"
                variant="outlined"
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid item xs={2}>
              <Button
                onClick={handleClear}
                className="dButton dButton2"
                variant="contained"
              >
                Clear
              </Button>
            </Grid>

            <Grid item xs={3} margin="0 auto ">
              {!action && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "5px",
        }}
      >
        <button
          className="small-btn"
          style={{ visibility: data ? "visible" : "hidden" }}
          onClick={() => {
            if (data) {
              exportGridDataAsCSV();
            }
          }}
        >
          Export as CSV
        </button>
      </div>
      {data && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={12}
            pagination={true}
            domLayout="autoHeight"
            rowData={data}
            columnDefs={columnDefs}
            enableCellTextSelection={true}
          ></AgGridReact>
        </div>
      )}
    </motion.div>
  );
};

export default CreditSimStatus;
